/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
import net from 'net';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { tencentDocOpenUrlReload } from '@tencent/tencent_doc_open_url';
import type { preprocessUrlOption } from '@tencent/tencent_doc_open_url/dist/cjs/interface';
import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import { EMAIL_PREFIX } from '@src/slide/domain/ui-model/element-modeles/property/link/constant/prefix';
import { ScriptLoader } from './script-loader';
import { isCorrectUrl } from '@src/utils/verify-link';
import { IS_ENTERPRISE, LINK, RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { camelCase } from 'camel-case';
import _isObject from 'lodash/isObject';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

export function isLogin() {
    const adapter = (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices)
        ?.viewableServiceLayer.extensionService?.getCallBackAdapter();
    return adapter?.isLogin?.() || false;
}

export function getSecretId(): string {
    const id = window.location.pathname.split('/').pop();
    return id || '';
}

/**
 * 当前是否已登录
 * 该方法只用于离线模式下，其他情况请使用下方的isLogin
 */
export function isLoginWithCookie(): boolean {
    return isLogin() || isLocalDebug();
}

/** @deprecated 不再推荐使用 `LOCAL_DEBUG` 环境变量，使用 `__IS_DEV__` */
export function isLocalDebug(): boolean {
    return (process.env.NODE_ENV === 'development' && process.env.LOCAL_DEBUG === '1');
}

/** @deprecated 使用 `__IS_PROD__` or `process.env.NODE_ENV === 'production'`, 惰性求值会使 webpack treeshaking 失效  */
export function isProduction(): boolean {
    return process.env.NODE_ENV === 'production';
}

/* istanbul ignore next */
/**
 * @deprecated 正式环境标识
 *
 * 使用以下写法替代:
 * ```
 * import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
 * ENV.IS_RELEASE
 * ```
 */
export function isReleaseBuild(): boolean {
    return ENV.IS_RELEASE;
}

/**
 * @deprecated 测试环境标识
 *
 * 使用以下写法替代:
 * ```
 * import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
 * ENV.IS_TEST
 * ```
 */
export function isTestEnvId(): boolean {
    return ENV.IS_TEST;
}

function getWxRedirectUrl(url: string): string {
    const docEditPageRegExp = new RegExp(`^https:${RUNTIME.API_ROOT}(sheet|doc|slide|form|pdf|file)/(.*)$`);
    const isTencentDocEditPage = docEditPageRegExp.test(url);
    return isTencentDocEditPage ? '/pages/detail/detail' : '/pages/webview/webview';
}

function needReplaceUrl(url: string): boolean {
    return url.indexOf(LINK.REPORT) > -1 && browser.isIOS && browser.isMobileQQBrowser;
}

/**
 *  统一使用@tencent/tencent_doc_open_url组件打开链接
 */
export function openURLInMobile(url: string) {
    const options = {
        url,
        replace: false,
        windowName: '_blank',
    };
    if (needReplaceUrl(url)) {
        options.replace = true;
    }
    openUrlForAll(options);
}

export const getRedirectUrl = (url: string): string => {
    if (isCorrectUrl(url) && url.indexOf(EMAIL_PREFIX) !== 0 && url.indexOf('http') !== 0) {
        return `http://${url}`;
    }

    return url;
};

/**
 * 统一使用@tencent/tencent_doc_open_url组件打开链接
 * @param {*} url
 * @param {*} newWindow 是否打开新窗口
 * @returns
 */
export function openUrlWithCheck(url: string, newWindow = false): void {
    // 微信、QQ小程序兼容
    if (browser.isMiniProgram) {
        const scenarioUrl = getScenarioUrl(url); // 中转url，防止xss注入安全问题
        const docEditPageRegExp = new RegExp(`^https:${RUNTIME.API_ROOT}(sheet|doc|slide|form|pdf|file)/(.*)$`);
        const isTencentDocEditPage = docEditPageRegExp.test(url);
        const wxUrl = isTencentDocEditPage ? '/pages/detail/detail' : '/pages/webview/webview';
        window.wx?.miniProgram?.navigateTo?.({
            url: `${wxUrl}?url=${encodeURIComponent(isTencentDocEditPage ? url : scenarioUrl)}`,
        });
        return;
    }
    const ignoreDomainDetect = url?.indexOf(EMAIL_PREFIX) === 0;
    // windowName和windowFeatures同时存在会使用window.open打开新窗口，不使用a标签跳转
    const options: preprocessUrlOption = {
        url,
        replace: false,
        windowName: '_blank',
        ignoreDomainDetect,
    };
    if (newWindow) {
        options.windowFeatures = 'noreferrer=yes';
    }
    openUrlForAll(options);
}

export function getScenarioUrl(url: string) {
    const { clientVars } = window;
    const extra = clientVars ? `&pid=${clientVars.globalPadId}&cid=${clientVars.creatorId}` : '';
    return `https://${window.hostname}/scenario/link.html?url=${encodeURIComponent(url)}${extra}`;
}

// 刷新当前页面
export function reloadInMobile() {
    const url = location.href;
    // wx/qq 小程序
    if (browser.isMiniProgram) {
        const wxUrl = getWxRedirectUrl(url);
        window.wx.miniProgram.redirectTo({
            url: `${wxUrl}?url=${encodeURIComponent(url)}`,
        });
    } else if (window.mqq && window.mqq.QQVersion !== '0') {
        window.mqq.ui.openUrl({
            url,
            target: 0,
            style: 0,
        });
    } else {
        tencentDocOpenUrlReload();
    }
}


/**
 *  判断移动端是否是竖屏
 *  true - 竖屏
 *  false - 横屏
 */

export function isPortrait(): boolean {
    if (typeof window.orientation === 'number') {
        return (window.orientation / 90) % 2 == 0;
    }
    try {
        const { angle } = window.screen.orientation;
        if (typeof angle === 'number') {
            return (angle / 90) % 2 == 0;
        }
    } catch (err) {
        // ignore
    }
    return true;
}

export function isLandscape(): boolean {
    return !isPortrait();
}

declare global {
    interface Document {
        mozHidden?: any;
        msHidden?: any;
        webkitHidden?: any;
    }
}

export function getAdaptVisibilityStr(): string {
    let visibilityChange = 'visibilitychange';
    if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
        visibilityChange = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
    }
    return visibilityChange;
}

export function getAdaptHiddenStr(): string {
    let hidden = 'hidden';
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
    } else if (typeof document.mozHidden !== 'undefined') {
        hidden = 'mozHidden';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
    }
    return hidden;
}

/**
 * 初始化服务端配置，这里需要指定的时间执行，因为需要从服务端拉取配置
 */
export function ifVipFeatureEnable(cb: (canVip: boolean, ioscanpay: boolean) => void): void {
    // eslint-disable-next-line @tencent/tencent-docs-slide/slide-diff-check
    if (__IS_PRIVATE_WECOM__) {
        return;
    }
    (net as any).ajaxPost({
        url: `//${window.hostname}/cgi-bin/online_docs/common_config`,
        type: 'POST',
        xhrFields: { withCredentials: true },
        param: {
            keys: JSON.stringify(['canvip', 'ioscanpay']),
        },
        success(data: string): void {
            let res: any = {};
            let configs: any = {};
            let canVip: any = {};
            let ioscanpay: any = {};
            res = safeStringToObj(data, res);
            configs = safeStringToObj(res.configs, configs);
            canVip = configs ? safeStringToObj(configs.canvip, canVip) : false;
            ioscanpay = configs ? safeStringToObj(configs.ioscanpay, ioscanpay) : false;
            if (res.cgicode === 0 && res.retcode === 0 && canVip.enable === 1) {
                cb(canVip.enable === 1, ioscanpay.enable === 1);
            }
        },
    });
}

function safeStringToObj(argv: string, deft) {
    let res = deft;
    if (typeof argv === 'string') {
        try {
            res = JSON.parse(argv);
        } catch (err) {
            // ignore
        }
    } else if (typeof argv === 'object') {
        res = argv;
    }
    return res;
}

export function substr2(str: string, len: number, tail = '..'): string {
    const { length } = str;
    let output = '';
    let outputLen = 0;
    let index = 0;

    while (index < length) {
        const charCode = str.charCodeAt(index);
        const character = str[index];

        if (charCode >= 0xd800 && charCode <= 0xdbff) {
            index += 1;
            output += character + str[index];
        } else {
            output += character;
        }

        outputLen += 1;

        index += 1;

        if (outputLen >= len) {
            break;
        }
    }

    if (index < length) {
        output += tail;
    }

    return output;
}

export const safeLoadSLR = (ScriptLoader, module: string, cb, ...rest) => {
    const loadModule = () => {
        ScriptLoader.load(module, cb, ...rest);
    };
    if (!ScriptLoader.assetLoaded) {
        ScriptLoader.listen('SL-INIT', () => {
            loadModule();
        });
    } else {
        loadModule();
    }
};

export const initScriptLoader = () => {
    const version = IS_ENTERPRISE ? 'v11' : 'v1';
    ScriptLoader.init(`//${RUNTIME.DOMAIN_NAME}/components/feature/assets.${version}.json`);
};

export const isWeworkUser = () => {
    if (config.supportEnterprise(EnterPriseType.ALL)) {
        // 迁移 B 端的逻辑，具体问 @peipeiwang，我请她喝了咖啡
        return isWeworkUserForEnterprise();
    }

    let isWeworkUser = false;
    if (window.clientVars?.userInfo) {
        // corpId不为空 & 有灰度标识
        const { isGrayed, corpId } = window.clientVars.userInfo;
        if (corpId && isGrayed) {
            isWeworkUser = true;
            window.clientVars.isToBUser = true;
        }
    }

    return isWeworkUser;
};

export const isWeworkUserForEnterprise = () => {
    let isWeworkUser = true;
    let user;
    if (window.basicClientVars) {
        user = window.basicClientVars.userInfo;
    } else {
        user = window.clientVars?.userInfo;
    }

    if (user && user.corpId === '') {
        isWeworkUser = false;
        window.clientVars.isCVisitB = true;
    }

    return isWeworkUser;
};

// 检测是否是B端用户访问C端文档
export const isBVisitC = (): boolean => isWeworkUser() && !config.supportEnterprise(EnterPriseType.ALL);

// 检测是否是C端用户访问B端文档
export const isCVisitB = (): boolean => !isWeworkUser() && config.supportEnterprise(EnterPriseType.ALL);

// 将对象改成驼峰式
export const camelize = (input) => {
    if (!_isObject(input)) return input;
    if (Array.isArray(input)) return input.map(camelize);
    return Object.keys(input).reduce((prev, key) => {
        Object.defineProperty(prev, camelCase(key), {
            value: camelize(input[key]),
        });
        return prev;
    }, {});
};

declare global {
    interface Window {
        camelize: (input) => any;
    }
}
window.camelize = camelize;
